import { dataKit } from '@xmindltd/snowmonster'
import { generateShortUUID } from 'utils/shortUUID'
import { $T } from 'client/library/translation'

const getContentJSON = () => {
  return [
    {
      id: generateShortUUID(),
      class: 'sheet',
      rootTopic: {
        id: generateShortUUID(),
        class: 'topic',
        title: $T('Central Topic'),
        titleUnedited: true,
        children: {
          attached: [
            { id: generateShortUUID(), title: `${$T('Main Topic')} 1`, titleUnedited: true },
            { id: generateShortUUID(), title: `${$T('Main Topic')} 2`, titleUnedited: true },
            { id: generateShortUUID(), title: `${$T('Main Topic')} 3`, titleUnedited: true },
            { id: generateShortUUID(), title: `${$T('Main Topic')} 4`, titleUnedited: true },
          ],
        },
      },
      title: `${$T('Map')} 1`,
      topicOverlapping: 'overlap',
      extensions: [
        {
          provider: 'org.xmind.ui.skeleton.structure.style',
          content: {
            centralTopic: 'org.xmind.ui.map.clockwise',
            mainTopic: 'org.xmind.ui.logic.right',
          },
        },
      ],
      theme: {
        centralTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '30pt',
            'fo:font-weight': '800',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'center',
            'svg:fill': '#000000',
            'fill-pattern': 'none',
            'line-width': '2pt',
            'line-color': '#ADADAD',
            'line-pattern': 'solid',
            'border-line-color': '#000000',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.curve',
            'arrow-end-class': 'org.xmind.arrowShape.none',
            'alignment-by-level': 'inherited',
          },
        },
        mainTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '18pt',
            'fo:font-weight': '500',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': 'inherited',
            'fill-pattern': 'solid',
            'line-width': '2pt',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': 'inherited',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        subTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': 'inherited',
            'fill-pattern': 'none',
            'line-width': '2pt',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': 'inherited',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        floatingTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '500',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': '#EEEBEE',
            'fill-pattern': 'solid',
            'line-width': '2pt',
            'line-color': 'inherited',
            'line-pattern': 'solid',
            'border-line-color': '#EEEBEE',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'org.xmind.arrowShape.none',
            'alignment-by-level': 'inherited',
          },
        },
        summaryTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': '#000000',
            'fill-pattern': 'none',
            'line-width': 'inherited',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': '#000000',
            'border-line-width': 'inherited',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        calloutTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'svg:fill': '#000000',
            'fill-pattern': 'solid',
            'line-width': 'inherited',
            'line-color': 'inherited',
            'line-pattern': 'inherited',
            'border-line-color': '#000000',
            'border-line-width': 'inherited',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        level3: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'left',
            'fill-pattern': 'solid',
            'line-width': '2pt',
            'line-pattern': 'inherited',
            'border-line-width': '0pt',
            'border-line-pattern': 'inherited',
            'shape-class': 'org.xmind.topicShape.roundedRect',
            'line-class': 'org.xmind.branchConnection.roundedElbow',
            'arrow-end-class': 'inherited',
            'alignment-by-level': 'inherited',
          },
        },
        importantTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-weight': 'bold',
            'svg:fill': '#7F00AC',
            'fill-pattern': 'solid',
            'border-line-color': '#7F00AC',
            'border-line-width': '0',
          },
        },
        minorTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:font-weight': 'bold',
            'svg:fill': '#82004A',
            'fill-pattern': 'solid',
            'border-line-color': '#82004A',
            'border-line-width': '0',
          },
        },
        expiredTopic: {
          id: generateShortUUID(),
          properties: {
            'fo:text-decoration': 'line-through',
            'fill-pattern': 'none',
          },
        },
        summary: {
          id: generateShortUUID(),
          properties: {
            'line-width': '2pt',
            'line-color': '#000000',
            'line-pattern': 'solid',
            'shape-class': 'org.xmind.summaryShape.round',
          },
        },
        boundary: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '14pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'center',
            'svg:fill': '#9B9B9B',
            'fill-pattern': 'solid',
            'line-width': '2',
            'line-color': '#00000066',
            'line-pattern': 'dash',
            'shape-class': 'org.xmind.boundaryShape.roundedRect',
          },
        },
        relationship: {
          id: generateShortUUID(),
          properties: {
            'fo:font-family': 'NeverMind',
            'fo:font-size': '13pt',
            'fo:font-weight': '400',
            'fo:font-style': 'normal',
            'fo:color': 'inherited',
            'fo:text-transform': 'manual',
            'fo:text-decoration': 'none',
            'fo:text-align': 'center',
            'line-width': '2',
            'line-color': '#00000066',
            'line-pattern': 'dash',
            'shape-class': 'org.xmind.relationshipShape.curved',
            'arrow-begin-class': 'org.xmind.arrowShape.none',
            'arrow-end-class': 'org.xmind.arrowShape.triangle',
          },
        },
        map: {
          id: generateShortUUID(),
          properties: {
            'svg:fill': '#ffffff',
            'multi-line-colors': '#FF6B6B #FF9F69 #97D3B6 #88E2D7 #6FD0F9 #E18BEE',
            'color-list': '#FF6B6B #FF9F69 #97D3B6 #88E2D7 #6FD0F9 #E18BEE',
            'line-tapered': 'none',
          },
        },
        skeletonThemeId: '8f137afe-a0f3-4f25-b56a-cfd05993ef4b',
        colorThemeId: 'Dawn-#ffffff-MULTI_LINE_COLORS',
      },
    },
  ]
}

export const newMakerXmindFile = async () => {
  return await dataKit.deserializeDocument({ content: getContentJSON() })
}
